(function () {
  function start() {
    if (!window.L) {
      window.setTimeout(start, 50);
      return;
    }

    var el = document.getElementById("sunnier-showroom-map");
    var dataEl = document.getElementById("sunnier-showroom-map-data");
    if (!el || !dataEl) return;

    var locations;
    try {
      locations = JSON.parse(dataEl.textContent || "[]");
    } catch (error) {
      return;
    }

    locations = locations.filter(function (item) {
      return item && Number.isFinite(item.lat) && Number.isFinite(item.lng);
    });
    if (!locations.length) return;

    var map = L.map(el, { scrollWheelZoom: false });
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      maxZoom: 18,
    }).addTo(map);

    var bounds = [];
    locations.forEach(function (item) {
      var marker = L.marker([item.lat, item.lng]).addTo(map);
      var html =
        '<div class="sunnier-showroom__map-popup"><strong>' +
        escapeHtml(item.title || "Showroom") +
        "</strong><span>" +
        escapeHtml(item.address || "") +
        (item.comingSoon ? "<br>Coming soon" : "") +
        "</span></div>";
      marker.bindPopup(html);
      bounds.push([item.lat, item.lng]);
    });

    if (bounds.length === 1) {
      map.setView(bounds[0], 12);
    } else {
      map.fitBounds(bounds, { padding: [36, 36], maxZoom: 10 });
    }

    function refresh() {
      map.invalidateSize();
      if (bounds.length === 1) {
        map.setView(bounds[0], 12);
      } else {
        map.fitBounds(bounds, { padding: [36, 36], maxZoom: 10 });
      }
    }

    window.setTimeout(refresh, 200);
    window.addEventListener("resize", refresh);
    if (window.ResizeObserver) {
      new ResizeObserver(refresh).observe(el);
    }
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
